import { render, staticRenderFns } from "./DeliverySpo.vue?vue&type=template&id=23c25503&scoped=true&"
import script from "./DeliverySpo.vue?vue&type=script&lang=js&"
export * from "./DeliverySpo.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySpo.vue?vue&type=style&index=0&id=23c25503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c25503",
  null
  
)

export default component.exports